import React, { useState, useEffect } from 'react';
import H3Text from '@Uilib/h3Text';

const RefreshRequiredBanner = ({ timer }) => {

  return (
    <div className="refresh-required-wrapper__outer">
      <div className="refresh-required-wrapper">
        <H3Text
          text={(
            <div>
              New software update available! 🚀.
              The screen will automatically reload in&nbsp;
              {timer} seconds
            </div>
          )}
          className="refresh-required__text"
        />
        <div
          className="refresh-required__button"
          onClick={() => {
            window.location.reload(true);
          }}
        >
          Refresh Now
        </div>
      </div>
    </div>
  );
};

export default RefreshRequiredBanner;
